import React from 'react'
import { SettingsSectionV2 } from './SettingsSectionV2'

/*
 * System → Integrations → Segment: SEGMENT_HTTP_API_KEY, the write key the
 * backend sends dashboard page views to Segment with (segment-api.service).
 * A secret: admin_audit keeps only its last four characters.
 */
const GROUPS = [
  { key: 'segment', title: 'Segment', sub: 'Which dashboard pages users open — passed on to the tools connected in Segment' },
]

export function SegmentSettingsV2() {
  return (
    <SettingsSectionV2
      title="Segment"
      intro="Page view analytics for the dashboard. A value saved here replaces the ConfigMap one and works without a restart."
      groups={GROUPS}
      saveNote={() => 'Used from the next page view.'}
    />
  )
}
